import styled from 'styled-components'

export const TitleWrapper = styled.div`
  height: 56px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`

export const Actions = styled.div`
  margin-left: auto;
`

export const Title = styled.h4``

export const UpdateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 38px;
`

export const AccordionTitle = styled.h5`
  margin-bottom: 20px;
`

export const LongText = styled.div`
  max-width: 650px;
  gap: 8px;
  display: flex;
  flex-direction: column;
`

export const Panels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`
